<template>
  <v-layout column px-4>
    <v-layout v-show="jobDetails.JobInfo.HasFilter" column>
      <p
        class="display-18 font-weight-medium primary--text mt-3 mb-0"
        v-html="
          jobDetails.JobInfo.Lang === langTypeEn ||
          jobDetails.JobInfo.Lang === 'English'
            ? filtersTitleEn
            : filtersTitleHeb
        "
      ></p>
      <v-flex>
        <ul class="mr-4 mt-2 display-18">
          <li
            v-for="(item, index) in jobDetails.JobContent.Filters"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
      </v-flex>
    </v-layout>

    <v-row class="job-footer pt-2 pb-0 wrap">
      <v-col
        cols="12"
        :md="showRank ? 6 : 12"
        class="job-footer-right shrink py-0"
      >
        <v-row
          align-self-center
          text-right
          class="pr-3 my-3"
          v-show="canDisplay"
        >
          <v-icon
            class="icon-resume display-18 pb-1 pl-2"
            color="primary"
          ></v-icon>
          <nuxt-link
            :to="`/${jobDetails.Company.ToUrl}`"
            class="no-underline-all"
            :prefetch="false"
          >
            <span class="display-18 no-underline">
              לפרופיל החברה ומשרות נוספות
            </span>
            <span class="url-sign d-inline-flex display-14">></span>
          </nuxt-link>
        </v-row>
        <v-row wrap justify-center v-if="!isSingleJob">
          <v-col
            cols="12"
            class="display-18 pointer flex-center pc-view"
            @click="$emit('closeJob', $event)"
          >
            - סגירת פרטי המשרה
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6" class="rank-box" v-if="showRank">
        <Rank :jobCode="jobDetails.JobInfo.JobCode" />
      </v-col>
    </v-row>
    <v-row class="px-4 mt-2 pc-view" v-if="!isSingleJob">
      <v-col>
        <v-icon class="display-12 u" color="black">mdi-open-in-new</v-icon>
        <nuxt-link
          :target="'_blank'"
          :to="`${jobDetails.JobInfo.Link}`"
          title="'פתח משרה בחלון חדש'"
          class="px-1 no-underline black--text'"
          color="black"
          :prefetch="false"
        >
          <span class="display-12 black--text">פתח משרה בחלון חדש</span>
        </nuxt-link>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import Rank from '@/components/Jobs_List/Rank/Rank';

export default {
  components: {
    Rank,
  },
  props: {
    isFavorite: {
      type: Boolean,
    },
    jobDetails: {
      type: Object,
      required: true,
      default: () => {},
    },
    jobApplied: {
      type: Boolean,
    },
    isSingleJob: {
      type: Boolean,
    },
    canDisplay: {
      type: Boolean,
      required: false,
      default: true,
    },
    showRank: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      filtersTitleHeb: 'דרישות חובה',
      filtersTitleEn: 'Mandatory Requirements',
      filterModel: [],
      showShare: false,
      cvBtnDisabled: true,
      appliedForJob: this.jobApplied,
      cvSendingDate: this.sendingDate,
      langTypeEn: 2,
    };
  },

  computed: {
    ...mapGetters({
      checkIfAppliedForJob: 'checkIfAppliedForJob',
      sendCvDate: 'sendCvDate',
    }),

    sendingDate() {
      return this.checkIfAppliedForJob(this.jobDetails.Code)
        ? this.sendCvDate(this.jobDetails.Code)
            .substring(0, 10)
            .split('-')
            .reverse()
            .join('-')
        : '';
    },

    displayCvButton() {
      return !(this.jobApplied || this.appliedForJob);
    },
  },

  watch: {
    /**
     * @cvBtnDisabled is disabled if job filters uncheck
     * if job has no filter CV button will be enabled by default
     */
    filterModel() {
      // this.$emit('mandatoryRequirements', !this.$refs.filtersForm.validate());
    },
  },

  created() {
    this.appliedForJob = this.jobApplied;
  },

  mounted() {
    // this.$emit('mandatoryRequirements', this.jobDetails.JobInfo.HasFilter);
    this.$nuxt.$on('updateSendInfo', this.handleUpdateCVSend);
  },

  methods: {
    handleUpdateCVSend(confirmaitionDetails) {
      if (this.jobDetails.Code === confirmaitionDetails.jobDetails) {
        this.cvSendingDate = confirmaitionDetails.date;
        this.appliedForJob = true;
      }
    },

    markIfApplied() {
      this.appliedForJob = this.jobApplied;
    },
  },

  beforeDestroy() {
    this.$nuxt.$off('updateSendInfo');
  },
};
</script>

<style lang="scss" scoped>
.rank-box {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.job-footer {
  align-items: stretch;
  justify-content: center;
}

.job-footer-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media screen and (max-width: 959px) {
  .rank-box {
    justify-content: flex-start;
  }
}
</style>
